import { RouteConfig } from 'vue-router'

export const UPLOAD_PATH = '/upload'
export const UPLOAD_NAME = 'Upload'

export const uploadRoutesConfig: RouteConfig[] = [
  {
    path: UPLOAD_PATH,
    name: UPLOAD_NAME,
    component: () => import('@/features/upload/views/Upload.vue')
  }
]
